/**
 * Created by bicheng on 2018/3/1.
 */
const hrpeHome = r => require.ensure([], () => r(require('@/pages/hrpe/hrpe-home')), 'hrpeHome')
const hrpeGaugefill = r => require.ensure([], () => r(require('@/pages/hrpe/grugefill/list')), 'hrpeGaugefill')
const hrpeGuageapprove = r => require.ensure([], () => r(require('@/pages/hrpe/KPIapprove/gaugeapprove')), 'hrpeGuageapprove')
const hrpeScore = r => require.ensure([], () => r(require('@/pages/hrpe/score/list')), 'hrpeScore')
const hrpeScoreCard = r => require.ensure([], () => r(require('@/pages/hrpe/score/card')), 'hrpeScoreCard')
const hrpeResultapprove = r => require.ensure([], () => r(require('@/pages/hrpe/resultapprove/list')), 'hrpeResultapprove')
const hrpeResultapproveCard = r => require.ensure([], () => r(require('@/pages/hrpe/resultapprove/card')), 'hrpeResultapproveCard')
const hrpeMyresult = r => require.ensure([], () => r(require('@/pages/hrpe/myresult/list')), 'hrpeMyresult')
const hrpeMyCard = r => require.ensure([], () => r(require('@/pages/hrpe/myresult/card')), 'hrpeMyCard')
const grugeCommon = r => require.ensure([], () => r(require('@/pages/hrpe/grugefill/card')), 'grugeCommon')
const NavBar = r => require.ensure([], () => r(require('@/components/air-service/common/header')), 'NavBar')
const hrpeTarget = r => require.ensure([], () => r(require('@/pages/hrpe/target/list')), 'hrpeTarget')
export default [
  {
    path: '/hrpe-home',
    name: 'hrpe-home',
    components: {
      default: hrpeHome,
      navigation: NavBar
    },
    meta: {
      belong: 'air-service'
    },
    redirect: '/hrpe-myresult',
    children: [
      {
        path: '/hrpe-gaugefill',
        components: {
          default: hrpeGaugefill,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-guageapprove',
        components: {
          default: hrpeGuageapprove,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-score',
        components: {
          default: hrpeScore,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-score/card/:id/:psnid/:evaid/:turn',
        components: {
          default: hrpeScoreCard,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-resultapprove',
        component: hrpeResultapprove,
        components: {
          default: hrpeResultapprove,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-resultapprove/card/:evaobj/:scheva',
        components: {
          default: hrpeResultapproveCard,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-myresult',
        components: {
          default: hrpeMyresult,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-myresult/detailcard/:id',
        components: {
          default: hrpeMyCard,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-gaugefill/grugeCommon/:userid/:from',
        components: {
          default: grugeCommon,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        path: '/hrpe-guageapprove/grugeCommon/:userid/:from',
        components: {
          default: grugeCommon,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      // 新增
      {
        name: 'hrpe-targetprogressreport',
        path: '/hrpe-targetprogressreport',
        components: {
          default: hrpeTarget,
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        name: 'hrpe-targetprogressreport-detail',
        path: '/hrpe-targetprogressreport/detail',
        components: {
          default: () => import('@/pages/hrpe/target/detail'),
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      },
      {
        name: 'hrpe-Keyevents',
        path: '/hrpe-Keyevents',
        components: {
          default: () => import('@/pages/hrpe/Key-events/list'),
          navigation: NavBar
        },
        meta: {
          belong: 'air-service'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/hrpe.js